export default class Spark {
    constructor(client) {
        this.client = client
    }

    async all() {
        return await this.client.http().get("/spark")
    }

    async get(id) {
        return await this.client.http().get(`/spark/${id}`)
    }

    async update(id, data) {
        return await this.client.http().put(`/spark/${id}`, data)
    }

    async delete(id) {
        return await this.client.http().delete(`/spark/${id}`)
    }

    async create(data) {
        return await this.client.http().post(`/spark`, data)
    }

    async release(id, version) {
        return await this.client.http().put(`/spark/release/${id}/${version}`)
    }

    async deploy(id, version) {
        return await this.client.http().put(`/spark/deploy/${id}/${version}`)
    }

    async logs(id, env, options) {
        return await this.client.http().get(`/spark/logs/${id}`, {
            params: options,
            headers: {
                'X-Project-Env': env
            }
        })
    }
}